import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 1rem;
`;

const Title = styled.h1`
  ${(props) => props.theme.title};
`;

const ProductsPresenter = () => (
  <Container>
    <Title>Products</Title>
  </Container>
);

export default ProductsPresenter;
